<template>
  <div class="w-full">
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      <div
        v-for="(tech, idx) in technologies"
        :key="idx"
        class="flex items-center space-x-3 p-4 border border-gray-200 dark:border-gray-800 rounded-md bg-white dark:bg-black hover:border-gray-400 dark:hover:border-gray-500 transition-colors duration-300"
      >
        <div class="w-8 h-8 flex-shrink-0 flex items-center justify-center">
          <img :src="tech.src" :alt="tech.name" class="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300" />
        </div>
        <span class="font-sans font-medium text-sm text-gray-700 dark:text-gray-300">{{ tech.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TechCarousel",
  data() {
    return {
      technologies: [
        { name: 'JavaScript', src: require('@/assets/logos/js1.png') },
        { name: 'Vue.js', src: require('@/assets/logos/vue.png') },
        { name: 'React', src: require('@/assets/logos/react.png') },
        { name: 'PHP', src: require('@/assets/logos/php.png') },
        { name: 'Laravel', src: require('@/assets/logos/laravel.png') },
        { name: 'Python', src: require('@/assets/logos/python.png') },
        { name: 'Java', src: require('@/assets/logos/java.png') },
        { name: 'C', src: require('@/assets/logos/C.png') },
        { name: 'PostgreSQL', src: require('@/assets/logos/postgress.png') },
        { name: 'MySQL', src: require('@/assets/logos/mysql.png') },
      ],
    };
  },
};
</script>

<style scoped>
/* Removed animation styles for a clean, static grid */
</style>